// src/components/Attestation/AttestationDetails.js
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import attestationData from './attestationData';
import './AttestationDetails.css';

function AttestationDetails() {
  const { serviceId } = useParams();
  const service = attestationData.find((item) => item.id === serviceId);

  if (!service) {
    return (
      <section className="attestation-details-page">
        <h1>Service Not Found</h1>
        <p>The attestation service you are looking for does not exist.</p>
        <Link to="/attestation" className="back-button">Back to Attestation Services</Link>
      </section>
    );
  }

  return (
    <section className="attestation-details-page">
      <div className="attestation-details-container">
        <div
          className="attestation-details-image"
          style={{ backgroundImage: `url(${service.image})` }}
        ></div>
        <div className="attestation-details-content">
          <h1>{service.title}</h1>
          <p>{service.details}</p>
          <Link to={`/attestation/enquiry/${service.id}`} className="contact-button">
            Contact Us
          </Link>
        </div>
      </div>
      <Link to="/attestation" className="back-button">← Back to Attestation Services</Link>
    </section>
  );
}

export default AttestationDetails;
